import type { WeatherTileWidget } from '../../../widgets';
import {
  BindingRow,
  OptionalBindingRow,
  Section,
  patcher,
  type WidgetEditorProps,
} from '../fields';
import { AiHintSection } from './AiHintSection';

export function WeatherTileEditor(
  { widget, plantId, onChange }: WidgetEditorProps<WeatherTileWidget>,
) {
  const patch = patcher(widget, onChange);
  return (
    <>
      <Section title="Außenklima">
        <BindingRow
          label="Außentemperatur"
          value={widget.outsideTemperaturePoint}
          plantId={plantId}
          filter={{ valueType: 'number' }}
          onChange={(next) => patch({ outsideTemperaturePoint: next })}
        />
        <OptionalBindingRow
          label="Gedämpfte Außentemperatur"
          value={widget.attenuatedTemperaturePoint}
          plantId={plantId}
          filter={{ valueType: 'number' }}
          hint="Der Wert, mit dem der Regler rechnet. Erklärt, warum der Vorlauf nicht mitgefallen ist."
          onChange={(next) => patch({ attenuatedTemperaturePoint: next })}
        />
        <OptionalBindingRow
          label="Feuchte"
          value={widget.humidityPoint}
          plantId={plantId}
          filter={{ valueType: 'number' }}
          onChange={(next) => patch({ humidityPoint: next })}
        />
        <OptionalBindingRow
          label="Windgeschwindigkeit"
          value={widget.windSpeedPoint}
          plantId={plantId}
          filter={{ valueType: 'number' }}
          hint="Wind kündigt bei Wärmepumpen die Abtauung an."
          onChange={(next) => patch({ windSpeedPoint: next })}
        />
        <OptionalBindingRow
          label="Wettersymbol"
          value={widget.weatherIconPoint}
          plantId={plantId}
          filter={{ valueType: 'enum' }}
          hint="Aufzählung vom Regler: Sonnig, Bewölkt, Regen, Schnee."
          onChange={(next) => patch({ weatherIconPoint: next })}
        />
      </Section>

      <AiHintSection value={widget.ai} onChange={(next) => patch({ ai: next })} />
    </>
  );
}
